/**
 * /dashboard/performance/reviews/new — Create a review cycle
 * (Phase 7.3b). HR-admin only.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/performance/reviews/new/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { ReviewCycleForm } from "@/components/performance/review-cycle-form";
import { usePerformanceRoles } from "@/components/performance/use-performance-roles";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/reviews/new",
)({
  component: NewReviewCycleRoute,
});

function NewReviewCycleRoute() {
  const { isPerfAdmin } = usePerformanceRoles();
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <PerformanceModuleShell
      title="New review cycle"
      description="Create a cycle as a draft, then configure its questions and reviewer roster."
    >
      <PerformanceFeatureGate>
        <Card className="max-w-2xl">
          <CardContent className="py-6">
            {isPerfAdmin ? (
              <ReviewCycleForm />
            ) : (
              <p className="text-sm text-muted-foreground">
                Only HR can create review cycles.
              </p>
            )}
          </CardContent>
        </Card>
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
